import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { format } from "date-fns";

const MilkingViewModal = ({ open, onClose, record }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Milking Details</DialogTitle>
      <DialogContent dividers>
        {record ? (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 2,
              mt: 1,
            }}
          >
            <Typography variant="body2">
              <strong>Date:</strong>{" "}
              {format(new Date(record.date), "MMM dd, yyyy")}
            </Typography>
            <Typography variant="body2">
              <strong>Total (L):</strong> {record.total_production}
            </Typography>
            <Typography variant="body2">
              <strong>Morning (L):</strong> {record.morning_production}
            </Typography>
            <Typography variant="body2">
              <strong>Evening (L):</strong> {record.evening_production}
            </Typography>
            {record.animal_id && (
              <Typography variant="body2">
                <strong>Animal ID:</strong> {record.animal_id}
              </Typography>
            )}
          </Box>
        ) : (
          <Typography variant="body2">No record selected.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MilkingViewModal;
